/**
 * @chineseName 折叠面板
 * @subDescription m-ui组件 折叠面板
 */
import Collapse from './Collapse';
export default Collapse;